import { createFileRoute } from '@tanstack/react-router'

import { BreadcrumbTrail, PageHeader } from '@/components/ui'
import { SearchView } from '@/modules/documents'
import { useFetchDocumentFolders } from '@/modules/folders'

export const Route = createFileRoute('/_authenticated/documents/search/')({
  staticData: { title: 'Search' },
  component: DocumentsSearchView,
  shouldReload: false,
  validateSearch: (search: Record<string, unknown>) => ({
    q: search.q ? String(search.q) : undefined,
    folder: search.folder ? String(search.folder) : undefined,
  }),
})

function DocumentsSearchView() {
  useFetchDocumentFolders()

  return (
    <div className="space-y-6">
      <BreadcrumbTrail
        crumbs={[{ label: 'Documents', to: '/documents' }]}
        page="Search"
      />

      <PageHeader title="Search" />

      <SearchView />
    </div>
  )
}
